const initialState =
{
	// Data saver: not persisted (see root persist whitelist). Lives in this slice, not settings.
	lowBandwidthMode : false
};

const mediaSession = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'MEDIA_SESSION_SET_LOW_BANDWIDTH':
		{
			const { lowBandwidthMode } = action.payload;

			return { ...state, lowBandwidthMode };
		}

		default:
			return state;
	}
};

export default mediaSession;
